const createValidator = (validate, fieldName) => (value, allValues) => {
  const response = validate(value, allValues)
  return (
    response && {
      [fieldName]: response.message,
    }
  )
}

export default createValidator
